/* eslint-disable complexity */
import { NUMBER } from "../../constants/app-constants";

export const parseCmsChallanData = (cmsData) => {
    const { pageSections = [] } = cmsData || {};

    const getPageSection = (index) => pageSections[index]?.pageSection || {};

    return {
        seo: cmsData?.seo || null,
        breadcrumb: cmsData?.breadcrumb || null,
        heroBannerData: {
            title: getPageSection(0)?.title || "",
            description: [{text: getPageSection(0)?.description}] || [],
            inputChallanData: {...(getPageSection(0)?.meta || {}), challanCount: getPageSection(NUMBER.TEN)?.sectionData || 0},
            bannerData: getPageSection(0)?.sectionData || [],
            backgroundImage: getPageSection(0)?.sectionData?.desktopImage?.url || "",
            backgroundColor: getPageSection(0)?.backgroundColor || "",
            ctaText: getPageSection(0)?.ctaText || ""
        },
        whyPayChallanData: {
            title: getPageSection(1)?.title || "",
            whyPayChallanList: getPageSection(1)?.sectionData || []
        },
        trustChallanData: {
            title: getPageSection(NUMBER.TWO)?.title || "",
            backgroundColor: getPageSection(NUMBER.TWO)?.backgroundColor || "",
            trustData: getPageSection(NUMBER.TWO)?.sectionData || [],
            bannerImage: getPageSection(NUMBER.TWO)?.image || {}
        },
        howToPayChallanData: {
            title: getPageSection(NUMBER.THREE)?.title || "",
            howToPayChallanList: getPageSection(NUMBER.THREE)?.sectionData || [],
            preloadImage: getPageSection(NUMBER.THREE)?.image || {}
        },
        whyChallanIssueData: {
            title: getPageSection(NUMBER.FOUR)?.title || "",
            whyChallanIssueList: getPageSection(NUMBER.FOUR)?.sectionData || []
        },
        whatIsChallanData: {
            title: getPageSection(NUMBER.FIVE)?.title || "",
            description: getPageSection(NUMBER.FIVE)?.description || ""
        },
        challanTestimonialsData: {
            title: getPageSection(NUMBER.SIX)?.title || "",
            testimonialList: getPageSection(NUMBER.SIX)?.sectionData || []
        },
        challanShareData: {
            title: getPageSection(NUMBER.SEVEN)?.title || "",
            description: getPageSection(NUMBER.SEVEN)?.description || "",
            shareData: getPageSection(NUMBER.SEVEN)?.meta || {},
            backgroundColor: getPageSection(NUMBER.SEVEN)?.backgroundColor || "",
            ctaText: getPageSection(NUMBER.SEVEN)?.ctaText || "",
            ctaRedirectUrl: getPageSection(NUMBER.SEVEN)?.ctaRedirectUrl || "",
            image: getPageSection(NUMBER.SEVEN)?.image || {}
        },
        challanStateListData: {
            title: getPageSection(NUMBER.EIGHT)?.title || ""
        },
        challanFaqData: {
            title: getPageSection(NUMBER.NINE)?.title || "",
            faqList: getPageSection(NUMBER.NINE)?.sectionData || []
        }
    };
};
